import request from '@/utils/request'
let baseURL = '/mall-system';

// 获取简单的上传凭证
export function simpleToken() {
  return request({
    url: '/api/app/file/v1/simpleToken',
    method: 'post',
    baseURL,
    data: {}
  })
}
/*
{}
*/


// 获取上传凭证(上传敏感内容)
export function QiniuUpToken() {
  return request({
    url: '/api/app/file/v1/QiniuUpToken',
    method: 'post',
    baseURL,
    data: {}
  })
}

// -------------  industry-controller : 行业管理 --------------------------
// 获取行业数据
export function getIndustries(params) {
  return request({
    url: '/industry/v1/industries',
    method: 'get',
    baseURL,
    params
  })
}


// ----------------------   verify-code-controller : 验证码服务 ------------------------------
// 非中国大陆地区的电话头查询
export function getCountrys(params) {
  return request({
    url: '/Country/v1/getCountrys',
    method: 'get',
    baseURL,
    params
  })
}
// 发送手机/邮箱验证码
export function sendVerifyCode(data) {
  return request({
    url: '/VerifyCode/v1/sendVerifyCode',
    method: 'post',
    baseURL,
    data
  })
}
